import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

export const initializeDatabaseRovoSelection = () => {
  waitForContentAPI().then((contentAPI) => {
    contentAPI?.publishDatabaseReferencingContent?.([]);
  });
};
